<template>
  <div class="animated fadeIn">
    <b-row class="ml-2">
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div 
            slot="header" 
            style="display:flex; justify-content:space-between; align-items:center; width:100%;" 
          >
          <strong> Add Planned Vehicle Count </strong> 
            <b-row>
              <b-col>
                <button type="button" class="btn btn-success mr-4"  @click="openAddConfiguration">
                  Add Vehicle Count
                </button>

                <button type="button" class="btn btn-info text-white" @click="uploadBulkCSV">
                  Bulk CSV Upload
                </button>
              </b-col>                 
            </b-row>
          </div>
          <b-row>
            <b-col md="12" >
              <!-- Add Configuration Form -->
               <add_Planned_Vehicle_Count
                ref="addVehicleCountModal"
                :hubList="hubList"
                 @refreshListing="refreshVehicleListing">
               </add_Planned_Vehicle_Count>

              <!-- Bulk Upload Form -->
               <bulk_CSV_upload
                ref="uploadCSVfile"
                @refreshListing="refreshVehicleListing"> <!-- kuldeep change -->
               </bulk_CSV_upload>

              <!-- <div>
                    <b class="text-left">Total Records : <strong style="color: red;">{{(this.HubUserIDdeliveryConfig).length}}</strong></b>
                    <b class="text-right">                    
                      Table shows total planned vehicle count
                    </b>                    
              </div>            -->

              <div class="d-flex justify-content-between align-items-center">
                  <b> Total Records : <strong class="text-danger"> {{ HubUserIDdeliveryConfig.length }} </strong> </b>
                  <b class="text-primary"> Table shows total planned vehicle count </b>
              </div>

            </b-col>
            <b-col md="12" >
              <b-table 
                  responsive show-empty 
                  :busy="isBusy" 
                  :items="paginatedData" 
                  :fields="fields"  
                  :bordered="bordered"    
                  :filter="filter"   
                  :sort-by.sync="sortBy"  
                  :sort-desc.sync="sortDesc"   
                  :sort-direction="sortDirection"  
                  @filtered="onFiltered" :tbody-tr-class="rowClass"> 

                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle">
                    </b-spinner>
                    <strong>Loading...</strong>
                  </div> 

                  <template slot="planned_date"  slot-scope="row">   <!--#cell(planned_date)="row" -->
                    {{ row.item.planned_date }}
                  </template>

                  <!-- <template v-for="hub in hubList" v-slot:[`cell(${hub.hub_name})`]="row" >
                    <div class="text-center">
                        <span v-if="row.item[hub.hub_name] && row.item[hub.hub_name].total > 0" 
                          v-b-tooltip.hover 
                          :title="`Regular : ${row.item[hub.hub_name].regular} Adhoc : ${row.item[hub.hub_name].adhoc}`">
                            {{ row.item[hub.hub_name].total }}
                        </span>
                        <span v-else>
                            -
                        </span>
                    </div>
                </template> -->

                <template
    v-for="hub in hubList"
    v-slot:[`cell(${hub.hub_name})`]="row"
>
    <div class="text-center">

        <span
            v-if="row.item[hub.hub_name] && row.item[hub.hub_name].total > 0"
            v-b-tooltip.hover
            :title="`Regular: ${row.item[hub.hub_name].regular} Adhoc: ${row.item[hub.hub_name].adhoc}`"
        >
            {{ row.item[hub.hub_name].total }}
        </span>

        <span v-else>
            -
        </span>

    </div>
</template>

                <template slot="checkLogs" slot-scope="row">   
                  <button class="btn btn-link p-0" @click="checkLogs(row.item)">
                    <i class="fa fa-eye"></i>
                  </button>
                </template>

              
              </b-table>


              <paginate
                  :page-count="noofpages"
                  :page-range="8"
                  :margin-pages="1"
                  :click-handler="clickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                  :page-class="'page-item'">
              </paginate>
            </b-col>
          </b-row> 
        </b-card>
         
      </b-col>
    </b-row> 

      <b-modal id="plannedVehicleLogsModal"
      title="Planned Vehicle Count Logs"
      size="xl"
      hide-footer
  >

  <b-table
      :items="logsData"
      :fields="logsFields"
      bordered
      responsive
      show-empty
  >


    <template slot="last_modified_date" slot-scope="row">
        {{ row.item.last_modified_date ? formatDate(row.item.last_modified_date) : showDash(row.item.last_modified_date) }}
    </template>

    <template slot="hub_title" slot-scope="row">
        {{ showDash(row.item.hub_title) }}
    </template> 

    <template slot="activity" slot-scope="row">
        {{ showDash(row.item.activity) }}
    </template>

    <template slot="created_by" slot-scope="row">
        {{ showDash(row.item.created_by) }}
    </template>

    <template slot="regular_vehicle_count" slot-scope="row">
        {{ showDash(row.item.regular_vehicle_count) }}
    </template>

    <template slot="adhoc_vehicle_count" slot-scope="row">
        {{ showDash(row.item.adhoc_vehicle_count) }}
    </template>
  </b-table>

  </b-modal>
  </div>
</template>

<script>

import add_Planned_Vehicle_Count from './addPlannedVehicleCount'
import bulk_CSV_upload  from './uploadBulkCSVfile.vue'
import CONSTANTS from '@/utils/constants'
export default{

  data: function(){
    return {
      isBusy: false, 
      currentPage: 1,

      perPage: 8,
      noofpages: 0,

      hubList: [],
      fields: [],
      HubUserIDdeliveryConfig: [],
      paginatedData: [],
      logsData: [],

      logsFields:[
          {
              key:"last_modified_date",
              label:"Created Date"
          },
          {
              key:"hub_title",
              label:"Hub Name"
          },
          {
              key:"activity",
              label:"Activity"
          },
          {
              key:"created_by",
              label:"User Name"
          },
          {
              key:"regular_vehicle_count",
              label:"Regular Vehicle Count"
          },
          {
              key:"adhoc_vehicle_count",
              label:"Adhoc Vehicle Count"
          }
      ]
    }  
  },

  components:{
    add_Planned_Vehicle_Count,
    bulk_CSV_upload
  },

  created(){ 
    console.log("Created hook called");
    this.getPlannedVehicleListing();
  },

  methods:{

    prepareFields() {
        this.fields = [
            {
                key: "planned_date",
                label: "Planned Date"
            }
        ];

        this.hubList.forEach(hub => {
            this.fields.push({
                key: hub.hub_name,
                label: hub.hub_name,

                // formatter: value => {
                //     return value && value.total > 0 ? value.total : '-'; 
                // }

                formatter: value => {
                    return value && value.total > 0
                        ? value.total
                        : '-';
                },

                tdAttr: value => {
                    if (value && value.total > 0) {
                        return {
                            title: `Regular: ${value.regular} Adhoc: ${value.adhoc}`
                        };
                    }

                    return {};
                }

            });
        });

        this.fields.push({
            key: "checkLogs",
            label: "Check Logs"
        });
    },


    async getPlannedVehicleListing() {
      this.isBusy = true;
      this.$http.post(
          `${CONSTANTS.MIGRATION_API_URL}/getPlannedVehicleListing`
      ).then(result => {
          this.isBusy = false;
          if(result.body.returnmsg=="Successful"){
              // console.log(result.body.returnvalue);
              // this.HubUserIDdeliveryConfig = result.body.returnvalue;
              console.log(this.HubUserIDdeliveryConfig, 'HubUserIDdeliveryConfig')
              console.log(this.hubList, '|||||||||||||||||||hublist|||||||||||||')

              let response = result.body.returnvalue;

              this.HubUserIDdeliveryConfig = response.data;
              // this.hubList = response.hubs;

              this.hubList = response.hubs.map(hub => ({
                  hub_id: response.data[0][hub].hub_id,
                  hub_name: hub
              }));

              console.log(this.HubUserIDdeliveryConfig[0]);
              this.prepareFields();

              this.noofpages = Math.ceil(
                this.HubUserIDdeliveryConfig.length / this.perPage
              );

              this.clickCallback(1);

          }
      }).catch(err=>{
          this.isBusy=false;
          console.log(err);
      });
    },

    openAddConfiguration() {
        this.$bvModal.show("addVehicleCountModal");
    },

    checkLogs(item){
      
      let obj = {
          planned_date: item.planned_date
      };
      this.$http.post(
          `${CONSTANTS.MIGRATION_API_URL}/getPlannedVehicleLogs`, obj
      ).then(result=>{
          if(result.body.returnmsg=="Successful"){
              this.logsData=result.body.returnvalue;
              this.$bvModal.show("plannedVehicleLogsModal");
          }
      }).catch(err=>{
          console.log(err);
      });
  },

    uploadBulkCSV(){
      this.$bvModal.show("uploadCSVfile");
    },

    refreshVehicleListing() {
      this.getPlannedVehicleListing();
    },

    clickCallback(pageNum) {
      this.currentPage = pageNum;
      let start = (pageNum - 1) * this.perPage;
      let end = start + this.perPage;
      this.paginatedData = this.HubUserIDdeliveryConfig.slice(start, end);
    },

    formatDate(date) {
      if (!date) return null;

      let d = new Date(date);

      let year = d.getFullYear();
      let month = ("0" + (d.getMonth() + 1)).slice(-2);
      let day = ("0" + d.getDate()).slice(-2);

      return `${year}-${month}-${day}`;
    },

    showDash(value) {
        return value === null ||
               value === undefined ||
               value === ""
            ? "-"
            : value;
    },
    
  },


}

</script>

<style scoped>
.table-responsive{

    overflow-x:auto;
}

.table td{

    white-space:nowrap;

    text-align:center;
}

.table th{

    white-space:nowrap;

    text-align:center;
}
</style>